import React, { useCallback, useState } from 'react';
import Button from 'components/atoms/Button';
import FormInput from 'components/atoms/FormInput';
import PageTitle from 'components/atoms/PageTitle';
import Spinner from 'components/atoms/Spinner';
import showPwd from "../../../assets/svg/show.svg";
import hidePwd from "../../../assets/svg/hide.svg";
import Logo from "../../../assets/svg/SeerbitBrandLogo.svg";
import { Link, useNavigate } from 'react-router-dom';
import Alert from 'components/atoms/Alert';
import { validteEmail } from 'utils';
import { BASE_URL, getRequest, loggedUser_baseURL, postRequest } from 'services/http';
import { connect, useSelector } from 'react-redux';
import { setAuthRes, setUserLoggedIn } from '../../../redux/auth/auth.action';
import { setValues } from 'services/storage';

const Login = (props) => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [emailErr, setEmailErr] = useState('');
    const [passwordErr, setPasswordErr] = useState('');

    const [progressData, setProgressData] = useState<any>([]);

    const navigate = useNavigate();

    const formComplete = email !== '' && password !== '';
    const disabledBtn = !formComplete || loading;

    const headers = {
        'Content-Type': 'application/json',
    }

    const redirectFunction = (url) => {
        return navigate(url, {
            state: progressData
        })
    }

    const onboardingProgress = useCallback(async (token: string) => {
        const res = await getRequest(`${BASE_URL + loggedUser_baseURL}partner/progress`, {
            ...headers,
            'Authorization': `Bearer ${token}`,
        });

        setProgressData(res?.data?.data);

        if (res?.data?.responseCode === '00') {
            if (res?.data?.data.kycInfo === 'PENDING' || res?.data?.data.emails === 'PENDING' || res?.data?.data.settlement === 'PENDING') {
                if (res?.data?.data.kycInfo === 'PENDING') {
                    return redirectFunction(`/auth/kyc_info`);
                }
                if (res?.data?.data.emails === 'PENDING') {
                    return redirectFunction(`/auth/emails_info`);
                }
                if (res?.data?.data.settlement === 'PENDING') {
                    return redirectFunction(`/auth/settlement_info`);
                }
            } else if (res?.data?.data.kycInfo === 'COMPLETED' && res?.data?.data.emails === 'COMPLETED' && res?.data?.data.settlement === 'COMPLETED') {
                Alert('success', 'Login was successful');
                props.setUserLoggedIn(true);
            }
            setLoading(false);
        } else {
            setLoading(false);
        }
    }, []);

    const validationFunc = useCallback(
      async (reqData: { email: string; password: string }) => {
        const res = await postRequest(
          `${BASE_URL}auth/login`,
          headers,
          reqData
        );

        if (res?.data?.responseCode === "00") {
          if (res?.data?.data) {
            props.setAuthRes(res.data.data);
            await onboardingProgress(res?.data?.data?.token?.token);
          } else if (res?.data.message === "An OTP has been sent") {
            props.setUserLoggedIn(true);
            navigate("/auth/validate_2fa", {
              state: { userData: reqData },
            });
          }
        } else {
          Alert("error", res?.data?.message || "Login failed");
          setLoading(false);
        }
      },
      [navigate, props]
    );
      

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setLoading(true);

        const userData = {
            email: email,
            password: password
        }

        if (formComplete) {
            if (password.length < 3) {
                return setPasswordErr("Password should be at least 5 characters");
            } else {
                if (validteEmail.test(email)) {
                    return validationFunc(userData);
                } else {
                    return setEmailErr('Please enter a valid email');
                }
            }
        } else {
            return Alert('error', 'Please fill all fields')
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <span>
                <img src={Logo} alt='SeerbitLogo' className='mb-10 ' />
            </span>
            <PageTitle
                pageTitle='Login to your account'
                pageTitleStyle='font-semibold !text-2xl tablet:!text-xl'
                subTitle='Welcome back, please enter your details'
                subTitleStyle='!text-[16px] leading-7 !text-Black2'
            />
            <span className='flex flex-col gap-3'>
                <FormInput
                    type="email"
                    name="email"
                    placeholder="example@gmail.com"
                    inputStyle="border border-transparent text-Black2"
                    label="Email Address"
                    labelStyle="font-normal text-sm leading-6 text-Black2"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    validationErr={emailErr}
                />
                <FormInput
                    type={showPassword ? "text" : "password"}
                    name="passwd"
                    placeholder="********"
                    inputStyle="border border-transparent text-Black2 flex-row-reverse"
                    label="Password"
                    labelStyle="font-normal text-sm leading-6 text-Black2"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    validationErr={passwordErr}
                    img={showPassword ? showPwd : hidePwd}
                    imgStyle="cursor-pointer w-5 h-5 block"
                    imgOnClick={() => setShowPassword((prevState) => !prevState)}
                />
            </span>
            <span>
                <Button
                    btnType="submit"
                    btnText={
                        loading ? (
                            <Spinner
                                text="Loading..."
                                textStyle='text-white'
                            />
                        ) : (
                            "Sign in"
                        )
                    }
                    btnStyle={`${disabledBtn ? "cursor-not-allowed" : ""
                        } bg-black text-white px-6 py-3 mt-12 w-full`}
                    disabled={disabledBtn}
                    onClick={() => { }}
                />
            </span>

            <Link to="/auth/forgot_password" className="flex justify-start mt-3 text-sm leading-7 cursor-pointer w-fit text-PrimaryActive hover:underline hover:transition-all">
                Forgot password?
            </Link>
        </form>
    )
}

const mapStateToProps = (state: any) => ({
    user_authData: state.auth.user_authData,
    user_loggedIn: state.auth.user_loggedIn,
    bearerToken: state.auth.user_authData?.token?.token,
})

const mapDispatchToProps = (dispatch: any) => ({
    setAuthRes: (data: any[]) => dispatch(setAuthRes(data)),
    setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login);